import React from "react";
import classes from "./List.module.scss";

const List = (props) => {
  return <li className={classes.List}>&middot;{props.list}</li>;
};

export default List;
